import apiService from './apiService';

/**
 * Public blog API (no auth)
 */
class BlogService {
    async getAll(page = 1, limit = 12, search = '') {
        const params = { page, limit };
        if (search && String(search).trim()) {
            params.search = String(search).trim();
        }
        const response = await apiService.get('/ecommerce/blogs', params);
        return {
            blogs: response.data.blogs || [],
            pagination: response.data.pagination || {},
        };
    }

    async getBySlug(slug) {
        const response = await apiService.get(
            `/ecommerce/blogs/${encodeURIComponent(slug)}`
        );
        return response.data.blog;
    }
}

const blogService = new BlogService();
export default blogService;
